export class DonationCategory {
    donationCategoryID: number;
    contactID: number;
}

